import React from 'react';
import { motion } from 'framer-motion';

export const AttorneysSection = () => {
  const attorneys = [
    {
      name: 'Dominique James',
      bio: 'An active California attorney admitted on May 8, 2025, and a Yale Law School graduate, practicing with Latham & Watkins in Los Angeles. Focuses on corporate law, mergers and acquisitions, & business advisory matters.',
      barId: '360839',
    },
    {
      name: 'Devin S. Crowley',
      bio: 'An active California attorney admitted to the State Bar on December 2, 2014. Focuses on civil litigation, business law, legal counseling, dispute resolution, and client advocacy, assisting individuals and organizations with a wide range of legal matters.',
      barId: '300577',
    },
    {
      name: 'Joseph Lee',
      bio: 'An experienced attorney focused on corporate law, commercial transactions, business advisory, contract negotiations, and strategic legal guidance, helping businesses navigate complex legal and regulatory matters.',
      barId: '249435',
    },
    {
      name: 'Scott R James',
      bio: 'An accomplished attorney specializing in business law, commercial litigation, dispute resolution, risk management, and legal counsel, providing practical solutions for businesses and individual clients.',
      barId: '294378',
    },
  ];

  return (
    <section className="py-12 md:py-20 bg-white" data-testid="attorneys-section">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-sm font-medium tracking-widest uppercase text-[#E1A334] mb-4 block">
              Meet The Team
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-slate-900 mb-4">
              Our Attorneys
            </h2>
            <p className="text-slate-600 text-lg max-w-2xl mx-auto">
              Dedicated legal professionals committed to protecting your brand and business interests
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {attorneys.map((attorney, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ scale: 1.03, y: -5 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative rounded-3xl p-8 shadow-lg bg-gradient-to-br from-[#0A1C3E] to-[#1B2F5C] border border-[#E1A334]/20 hover:border-[#E1A334] hover:shadow-2xl hover:shadow-[#E1A334]/20 transition-all duration-300"
              data-testid={`attorney-card-${index}`}
            >
              <h3 className="font-heading font-bold text-2xl text-white mb-3">
                {attorney.name}
              </h3>
              <p className="text-slate-300 text-sm leading-relaxed mb-6">
                {attorney.bio}
              </p>
              <div className="border-t border-[#E1A334]/20 pt-4">
                <p className="text-[#E1A334] text-sm font-medium">
                  Bar ID: <span className="text-slate-300">{attorney.barId}</span>
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
